import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getUrlFilterPolicies, getUrlFilterCategories} from "../../../actions/actionFilters"
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";


class ViewUrlFilter extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentFilter: {}
        }
    }
  
    componentDidMount(){
        this.props.getUrlFilterPolicies();
        this.props.getUrlFilterCategories();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.filters.length > 0){
            let currentFilter = nextProps.filters.find(filters => filters.filter_policy_id === this.props.match.params.id);
            this.setState({currentFilter: currentFilter});
        }
    }

    category_mapping(filter_categories, categories){
        let out = {};
        categories.map(function (category, keyIndex){
            out[category.label] = filter_categories[category.id];
        });
        return out;
    }

    render(){
        const {currentFilter} = this.state;
        const {categories} = this.props;
        let updated_categories = {};
        if (currentFilter.categories && categories.length >0){
            updated_categories = this.category_mapping(currentFilter.categories, categories)
        }
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card>
                            <CardHeader>
                                <strong>View Web Filter Policy</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentFilter && updated_categories ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Id</h4></td><td>{currentFilter.filter_policy_id ? currentFilter.filter_policy_id : "-"}</td></tr>
                                                        <tr><td><h4>Name</h4></td><td>{currentFilter.filter_policy_name ? currentFilter.filter_policy_name : "-"}</td></tr>
                                                        <tr><td><h4>Description</h4></td><td>{currentFilter.filter_policy_descriptions ? currentFilter.filter_policy_descriptions : "-"}</td></tr>
                                                        <tr><td><h4>Deny By Default</h4></td><td>
                                                        <img src={currentFilter.deny_by_default ? iconYes  : iconNo } alt="iconNo"/>
                                                            </td></tr>
                                                        <tr><td><h4>Domain Blacklist</h4></td><td className="word-wrap"><ReactJson src={currentFilter.domain_blacklist ? currentFilter.domain_blacklist : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td><h4>Domain Whitelist</h4></td><td className="word-wrap"><ReactJson src={currentFilter.domain_whitelist ? currentFilter.domain_whitelist : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td><h4>SSL Bypass Domains</h4></td><td className="word-wrap"><ReactJson src={currentFilter.ssl_bypass_domains ? currentFilter.ssl_bypass_domains : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td><h4>SSL Bypass IPs</h4></td><td className="word-wrap"><ReactJson src={currentFilter.ssl_bypass_ips ? currentFilter.ssl_bypass_ips : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td><h4>Enable Safe Search</h4></td><td>
                                                        <img src={currentFilter.enable_safe_search ? iconYes  : iconNo } alt="iconNo"/>
                                                            </td></tr>
                                                        <tr><td><h4>Safe Search Patterns</h4></td><td className="word-wrap"><ReactJson src={currentFilter.safe_search_patterns ? currentFilter.safe_search_patterns : []}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                        /></td></tr>
                                                        <tr><td><h4>Enable Categorization</h4></td><td>
                                                        <img src={currentFilter.enable_categorization ? iconYes  : iconNo } alt="iconNo"/>
                                                            </td></tr>
                                                        { currentFilter.enable_categorization ?
                                                            <React.Fragment>
                                                                <tr><td>Categories</td><td className="word-wrap"><ReactJson src={updated_categories}
                                                                        name={false}
                                                                        collapsed={false}
                                                                        sortKeys={true}
                                                                        collapseStringsAfterLength={40}
                                                                        enableClipboard={false}
                                                                        displayDataTypes={false}
                                                                /></td></tr>
                                                            </React.Fragment> : "-"
                                                        }
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewUrlFilter.propTypes = {
    filters: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        filters: state.filter.filters || [],
        categories: state.filter.categories || [],
    }),
dispatch => 
    ({  
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
        getUrlFilterCategories: () => dispatch(getUrlFilterCategories())
    }))(ViewUrlFilter);